<style lang="less">
  @import "./login.less";
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
          <p class="login-tip"></p>
        </div>
      </Card>
    </div>

    <div class="copyright">
      Copyright 2023 - 2024 ychushou.com所有 <a href="https://beian.miit.gov.cn">备案号:沪ICP备15058028号-3</a>
    </div>
  </div>
</template>

<script>
import LoginForm from '_c/login-form';
import { mapActions } from 'vuex';
export default {
  components: {
    LoginForm
  },
  methods: {
    ...mapActions(['handleLogin', 'getUserInfo']),
    handleSubmit ({ userId, password }) {
      // let postData = {
      //   userId: userName,
      //   password: passwordu
      // };
      // console.log('postData', postData);
      // // let _this = this;
      // this.$axios
      //   .request({
      //     url: 'caiji/?s=user.login',
      //     data: postData,
      //     method: 'POST'
      //   })
      //   .then(json => {
      //     let jsonData = json.data;
      //     console.log(jsonData.ret, jsonData);
      //     if (jsonData.ret === 200) {
      //       localStorage.setItem('token', jsonData.data.token);
      //       localStorage.setItem('userName', jsonData.data.userName);
      //       localStorage.setItem('lv', jsonData.data.lv);
      //       localStorage.setItem('userId', jsonData.data.userId);
      //       this.$router.push({
      //         name: this.$config.homeName
      //       });
      //     } else {
      //       this.$Message.error(jsonData.msg);
      //     }
      //   });

      /** 使用vuex */
      this.handleLogin({ userId, password }).then(res => {
        console.log('loginStatus', res);
        this.getUserInfo().then(res => {
          console.log('userInfo', res);
          if (res.ret === 200) {
            this.$router.push({
              name: this.$config.homeName
            });
          } else {
            this.$Message.error(res.msg);
          }
        });
      });
    }
  }
};
</script>

<style lang="css" scoped>
  .copyright {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    text-align: center;
  }
</style>
